import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useTable } from 'react-table'
import PropTypes from 'prop-types'
import Table from '../../../../../DataImport/Table/Table'
import { mapColumnHeaderToReactTableFormat } from '../../../../../../utils/mappers/analytics'
import ModifyActionCell from './ModifyActionCell/ModifyActionCell'


const TransitStockArrivalsTable = ({transitStockArrivals, materialName})=>{
    const { t } = useTranslation()
    const translateMapper = useMemo(()=>
                                {
                                return({
                                    material_name: t("simulation.materialTitle"),
                                    date: t("simulation.transitStockArrivalDate"),
                                    quantity: t("simulation.transitStockArrivalQuantity")})
                                }, [t])

    const columns = useMemo(()=>{
        if(transitStockArrivals.length){
            const transitStockArrivalOrder = {date:"", quantity: ""}
            const columns = mapColumnHeaderToReactTableFormat(transitStockArrivalOrder, translateMapper, "")
            const nameHeader = [{Header: translateMapper.material_name, accessor: "material_name",}]
            return nameHeader.concat(columns)
        }
        return []
    }, [transitStockArrivals, translateMapper])

    const data = useMemo(()=>{
        return transitStockArrivals.map((transitStockArrivalData)=>({...transitStockArrivalData,
                                                    material_name: materialName,
                                                    modify: <ModifyActionCell
                                                                data={transitStockArrivalData}
                                                                type="TransitStockArrivalsTable"
                                                                />
                                                }))

    }, [transitStockArrivals, materialName])

    const transitStockArrivalsTable = useTable({columns, data})

    return(
        <Table instance={transitStockArrivalsTable}/>
    )
}

TransitStockArrivalsTable.propTypes = {
    transitStockArrivals: PropTypes.array,
    materialName: PropTypes.string
}


export default TransitStockArrivalsTable;
